import { Base, createApp } from '@studiometa/js-toolkit';
import 'liquid-ajax-cart';
import Shop from './components/Shop/index.js';
import Sections from './components/Sections/index.js';
import PushMenu from './components/PushMenu/index.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Shop,
      Sections,
      PushMenu,
    },
  };
}

export default createApp(App, document.documentElement);
